module.exports = __webpack_public_path__ + "img/close.412d29a0.svg";